import type { Studio } from './types';
import { fmt, isoWeekdayOf, todayIn } from './time';

/** "Открыто до 21:00" / "Откроется в 10:00" / "Сегодня закрыто" in studio time. */
export function openStatus(studio: Pick<Studio, 'timezone' | 'hours' | 'exceptions'>, now = new Date()) {
  const day = todayIn(studio.timezone);
  const time = fmt(now, studio.timezone, 'HH:mm');
  const ex = studio.exceptions.find((e) => e.day === day);
  const windows = ex
    ? ex.is_closed
      ? []
      : [{ opens: ex.opens!, closes: ex.closes! }]
    : studio.hours.filter((h) => h.weekday === isoWeekdayOf(day));
  const current = windows.find((w) => time >= w.opens && time < w.closes);
  if (current) return { open: true, text: `Открыто до ${current.closes}` };
  const next = windows.find((w) => time < w.opens);
  if (next) return { open: false, text: `Откроется в ${next.opens}` };
  return { open: false, text: ex?.is_closed ? `Сегодня закрыто${ex.note ? ` · ${ex.note}` : ''}` : 'Сегодня уже закрыто' };
}
